import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Reloads the page on an interval while the feed is in its "scanning" state, so
// the placeholder is replaced by real mentions once the first ones land. Visits
// in place so the user's scroll position and filters are kept.
export default class extends Controller {
  static values = { interval: { type: Number, default: 20000 } }

  #timer

  connect() {
    this.#timer = setInterval(() => this.#refresh(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.#timer)
  }

  #refresh() {
    if (document.hidden) return
    Turbo.visit(window.location.href, { action: "replace" })
  }
}
